module.exports = __webpack_public_path__ + "img/613.Frodktim.f0037fec.svg";